export class VerifyAccountForm {
    firstName: string;
    lastName: string;
    email: string;
    confirmEmail: string;
    password: string;
    confirmPassword: string;
    termsCondition: boolean;
    constructor(item?: VerifyAccountForm) {
        this.firstName = item?.firstName ?? '';
        this.lastName = item?.lastName ?? '';
        this.email = item?.email ?? '';
        this.confirmEmail = item?.confirmEmail ?? '';
        this.password = item?.password ?? '';
        this.confirmPassword = item?.confirmPassword ?? '';
        this.termsCondition = item?.termsCondition ?? false;
    }
}

export interface VerifyAccountPayload {
    token: string;
    email: string;
    confirmationEmail: string;
    firstName: string;
    lastName: string;
    password: string;
    passwordConfirmation: string;
    overwrite?: boolean;
}

export interface VerifyAccountResponse {
    statusCode?: number;
    message?: string;
    expirationDate?: string;
    status: boolean;
}